/* Zabi Hair — Announcement bar mobiele carousel.
   Desktop (>749px): alle meldingen inline zichtbaar; JS doet niets.
   Mobiel (<=749px): toont 1 melding tegelijk, chevrons + autoplay wisselen. */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');

  function initBar(bar) {
    if (bar.__zabiInit) return;
    bar.__zabiInit = true;

    var items = Array.prototype.slice.call(
      bar.querySelectorAll('.zabi-announcement__item')
    );
    if (items.length < 2) return;

    var prev = bar.querySelector('.zabi-announcement__nav--prev');
    var next = bar.querySelector('.zabi-announcement__nav--next');
    var index = 0;
    var timer = null;

    function render() {
      items.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
    }
    function go(dir) {
      index = (index + dir + items.length) % items.length;
      render();
    }
    function start() {
      stop();
      if (!MQ.matches) return;
      timer = window.setInterval(function () { go(1); }, 4000);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    if (next) next.addEventListener('click', function () { go(1); start(); });

    function sync() {
      if (MQ.matches) {
        index = 0;
        render();
        start();
      } else {
        stop();
        items.forEach(function (el) { el.classList.remove('is-active'); });
      }
    }

    if (MQ.addEventListener) MQ.addEventListener('change', sync);
    else if (MQ.addListener) MQ.addListener(sync);
    sync();
  }

  function init() {
    document.querySelectorAll('.zabi-announcement').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
